import AppointmentFiltering from "../../../contexts/AppointmentFiltering";
import { useIsDesktop } from "../../../hooks/useIsDesktop.jsx";
import DesktopReservations from "./components/DesktopReservations";
import MobileReservations from "./components/MobileReservations";
export default function ReservationsPage() {
  return (
    <AppointmentFiltering>
      <Reservations />
    </AppointmentFiltering>
  );
}

function Reservations() {
  const isDesktop = useIsDesktop();
  if (isDesktop) {
    return <DesktopReservations />;
  }
  return <MobileReservations />;
}
